import { useQuery } from '@tanstack/react-query';
import { publicGet } from '@/lib/api/publicClient';
import { publicBookingEndpoints } from '@/lib/api/endpoints';
import type { BookingLinkConfig } from '@/types/onlineBooking';

export const bookingLinkKeys = {
  all: () => ['public', 'booking-link'] as const,
  config: (key: string) => [...bookingLinkKeys.all(), key] as const,
};

/** Public link config: branding + the services this link exposes. */
export function useBookingLinkConfig(key: string) {
  return useQuery<BookingLinkConfig>({
    queryKey: bookingLinkKeys.config(key),
    queryFn: () => publicGet<BookingLinkConfig>(publicBookingEndpoints.linkConfig(key)),
    enabled: !!key,
    staleTime: 5 * 60_000,
  });
}
